export default {
	totalSteps: 3,
	serviceGroupAddress:{
        list: []
    },
    services:{
        fetched: false,
        list: []
    },
    entitlementGroup: {
        list: []
    },
    servicesOfSelectedServiceGroup: {
        list:[]
    },
    getServerDate: {
        list: [],
        payload : null
    },
    availableBookingDatesOfAddress: {
        list : []
    },
    showModalRetry: false,
    showModalError: false,
    wasteStreams: {
        loading: false,
        fetched: false,
        list: [],
        error: ''
    },
    viewWasteStreams : {
        list : []
    },
    loadedWasteStreams : [],
    allWasteStreams : {
        list : []
    },
    woiWasteTypes: {
        loading: false,
        fetched: false,
        list: [],
        error: ''
    },
    woiItemTypes: {
        loading: false,
        fetched: false,
        list: [],
        error: ''
    },
    wasteVariation: {
        loading: false,
        fetched: false,
        list: [],
        error: ''
    },
    activeServiceGroup: null,
    activeServiceSetting: null,
    multipleCollection: {
        list : []
    },
    pricing: {
        loading: false,
        fetched: false,
        list: [],
        error: ''
    },
    activeStepIndex: 0,
    selectedBookingProducts: [],
    maxStreamPrice: null,
    // TransactionState
    bookingState : {
        activeAddress : null,
        activeAddressSetting : null,
        selectedServiceGroup : null,
        servicesOfServiceGroup : null,
        selectedService : null,
        isAgreedToTerms : null,
        hasEndTerms : null,
        entitlementSummary : null,
        selectedBookingProducts: [],
        selectedServiceEntitledCollection: null,
        comment: null,
        commentMap: {},
        collectionData: {
            periodType : null,
            selectedPeriod : null,
            preparationDate: null,
            preparationNote: null,
            pickupDate : null,
        },
        computedEntitlement : null,
        acceptedTerms: false,
        acceptedTerms2: false,
        acceptedTerms3: false,
        displayMultipleCollection : false,
        displayStreamQuantities : false,
        multipleCollectionCount: null,
        onlyUsedEntitlementCount: 0,
        personalInfo: null,
        receivingAgent: null,
        paymentAPI: null
    },
    mockMultipleCollectionCount: 0,
    bookingAcknowledged: false,
    paymentInfo: {
        error: null,
        loading: false,
        name: null,
        number: null,
        expiryMonth: null,
        expiryYear: null,
        cvn: null,
        valid: false
    },
    bookingSubmission: {
        form: null,
        loading: false,
        error: '',
        submitted: false,
        paymentBody : null
    },
    getDefaultData: '',
    bookingSummaryDetails: {},
    crn: null,
    wasteStreamsCombo: {
        loading: false,
        fetched: false,
        list: [],
        error: ''
    },
    wasteStreamsComboList: {
        list: []
    },
    serviceWording : {
        list : []
    },
    isCollectionWeekShown : true,
    searchInstructionSettings : {},
    serviceGroupWording : {},
    activeMultipleCollectionSetting: {},
    activeMultipleServiceBookingSetting: null,
    activeMultipleServiceSelectedBookingProducts: [],
    activeMultipleServiceSelectedBookingDates: [],
    activeMultipleServiceAcceptedBookingTerms: [],
    activeMultipleServiceMultipleCollectionCount: [],
    activeMultipleServiceComputedEntitlements: [],
    activeMultipleServiceEntitlementSummaries: [],
    activeMultipleServiceOtherBookingState: [],
    bookingCompletedDetails: null,
    additionalQuestions: null
}
